import { cacheRequest, saveCache } from 'src/store/vue-axios/cacheHttp.js'

const addEditCache = async (url, data, identifier = 'uuid') => {
  // if it's message deletion after first page, ignore
  // if it's new message, append to cache
  try {
    const existingCache = await cacheRequest(url)

    if (!existingCache?.data) return
    const existingItems = [...existingCache.data].filter(s => s[identifier] !== data[identifier])

    const updatedCache = { ...existingCache, data: [...existingItems, data] }
    saveCache(url, updatedCache)
  } catch {
    console.log('comes in cache problem')
  }
}

const modifyCache = (url) => {
  // modify the channel if it's in the cache
  // add channel if it's not in the cache yet
  try {
    const existingCache = cacheRequest(url)
    if (!existingCache) return
    console.log('existing', existingCache)
  } catch {
    console.log('comes in cache!!!')
  }
}

const modifyNewsStatsCache = async (url, newsId, data) => {
  try {
    const existingCache = await cacheRequest(url)

    if (!existingCache?.data) return

    const index = [...existingCache.data].findIndex(s => s.id === newsId)

    if (index === -1) return

    const existingNews = [...existingCache.data].find(s => s.id === newsId)
    const updatedNews = { ...existingNews, meta: { ...existingNews.meta, statistics: data } }

    const updatedList = Object.values({ ...existingCache.data, [index]: updatedNews })
    saveCache(url, updatedList)
  } catch {
    console.log('err updating news cache')
  }
}

export { addEditCache, modifyCache, modifyNewsStatsCache }
